import moment from 'moment';
import React, { Component } from 'react';
import { calendar, red_info, close_icon } from '../../../assets/images';

const months = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April ',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December',
};

const monthsProps = {
  0: {
    name: 'January',
    shortName: 'Jan',
    CalendarMonthNumber: 1,
  },
  1: {
    name: 'February',
    shortName: 'Feb',
    CalendarMonthNumber: 2,
  },
  2: {
    name: 'March',
    shortName: 'Mar',
    CalendarMonthNumber: 3,
  },
  3: {
    name: 'April ',
    shortName: 'Apr',
    CalendarMonthNumber: 4,
  },
  4: {
    name: 'May ',
    shortName: 'May',
    CalendarMonthNumber: 5,
  },
  5: {
    name: 'June ',
    shortName: 'Jun',
    CalendarMonthNumber: 6,
  },
  6: {
    name: 'July',
    shortName: 'Jul',
    CalendarMonthNumber: 7,
  },
  7: {
    name: 'August',
    shortName: 'Agu',
    CalendarMonthNumber: 8,
  },
  8: {
    name: 'September',
    shortName: 'Sep',
    CalendarMonthNumber: 9,
  },
  9: {
    name: 'October',
    shortName: 'Oct',
    CalendarMonthNumber: 10,
  },
  10: {
    name: 'November ',
    shortName: 'Nov',
    CalendarMonthNumber: 11,
  },
  11: {
    name: 'December',
    shortName: 'Dec',
    CalendarMonthNumber: 12,
  },
};

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const daysProps = {
  0: {
    name: 'Sunday',
    shortName: 'Sun',
    CalendarWeekdayNumber: 6,
  },
  1: {
    name: 'Monday',
    shortName: 'Mon',
    CalendarWeekdayNumber: 0,
  },
  2: {
    name: 'Tuesday',
    shortName: 'Tue',
    CalendarWeekdayNumber: 1,
  },
  3: {
    name: 'Wednesday',
    shortName: 'Wed',
    CalendarWeekdayNumber: 2,
  },
  4: {
    name: 'Thursday',
    shortName: 'Thu',
    CalendarWeekdayNumber: 3,
  },
  5: {
    name: 'Friday',
    shortName: 'Fri',
    CalendarWeekdayNumber: 4,
  },
  6: {
    name: 'Saturday',
    shortName: 'Sat',
    CalendarWeekdayNumber: 5,
  },
};

class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      date: '',
      displayDate: '',
      month: '',
      year: '',
      daysInMonthArr: [],
      blankDaysArr: [],
    };
  }

  componentDidMount() {
    this.init();
  }
  componentDidUpdate(prevProps, _) {
    if(prevProps.value !== this.props.value) this.init()
  }

  init = () => {
    const today = new Date();
    const month = this.props.value ? parseInt(moment(moment(this.props.value, 'DD-MM-YYYY - hh:mm a')).format('MM')) - 1 : today.getMonth();
    const year = this.props.value ? moment(moment(this.props.value, 'DD-MM-YYYY - hh:mm a')).format('YYYY') : today.getFullYear();

    const dayOfWeek = new Date(year, month).getDay();
    const Weekdays = daysProps[dayOfWeek]?.CalendarWeekdayNumber;
    // const displayDate = this.getDate(new Date(year, month, today.getDate()));
    const date = this.formatYearsMonthDay(new Date(year, month, today.getDate()));

    // Get last day number of the previous actual month
    const daysInMonth = new Date(year, month, 0).getDate();

    const day = moment(moment(this.props.value, 'DD-MM-YYYY')).format('DD')

    // Get the number (0-6) on which the actual month starts
    let blankDaysArr = [];
    for (let i = 1; i <= Weekdays; i++) {
      blankDaysArr.push(i);
    }

    let daysInMonthArr = [];
    for (let i = 1; i < daysInMonth; i++) {
      daysInMonthArr.push(i);
    }

    this.setState({
      date,
      displayDate: this.props.value ? this.props.value : '',
      month,
      year,
      day: this.props.value ? day : (new Date).getDate(),
      daysInMonthArr,
      blankDaysArr,
    });
  };

  setDate = (dayNumber) => {
    const dateToFormat = dayNumber ? new Date(this.state.year, this.state.month, dayNumber) : '';
    const date = dayNumber ? this.formatYearsMonthDay(dateToFormat) : '';
    const displayDate = dayNumber ? this.getDate(dateToFormat) : '';

    this.props.handler(displayDate);
    this.setState((prevState, _) => ({
      ...prevState,
      date,
      displayDate,
      isOpen: false,
    }));
  };

  addMonth = () => {
    let newYear = '';
    let newMonth = '';
    if (this.state.month === 11) {
      newMonth = 0;
      newYear = parseInt(this.state.year) + 1;
    } else {
      newMonth = this.state.month + 1;
      newYear = this.state.year;
    }

    const newMonthFirstWeekdayNumber = new Date(newYear, newMonth, 1).getDay();
    const firstWeekdayNumber = daysProps[newMonthFirstWeekdayNumber].CalendarWeekdayNumber;
    const daysInMonth = new Date(newYear, newMonth + 1, 0).getDate();

    let blankDaysArr = [];
    for (let i = 1; i <= firstWeekdayNumber; i++) {
      blankDaysArr.push(i);
    }

    let daysInMonthArr = [];
    for (let i = 1; i <= daysInMonth; i++) {
      daysInMonthArr.push(i);
    }

    this.setState((prevState, _) => {
      return {
        ...prevState,
        month: newMonth,
        year: newYear,
        daysInMonthArr,
        blankDaysArr,
        day:''
      };
    });
  };

  subtractMonth = () => {
    let newYear = '';
    let newMonth = '';
    if (this.state.month === 0) {
      newMonth = 11;
      newYear = parseInt(this.state.year) - 1;
    } else {
      newMonth = this.state.month - 1;
      newYear = this.state.year;
    }

    const newMonthFirstWeekdayNumber = new Date(newYear, newMonth, 1).getDay();
    const firstWeekdayNumber = daysProps[newMonthFirstWeekdayNumber].CalendarWeekdayNumber;
    const daysInMonth = new Date(newYear, newMonth + 1, 0).getDate();

    let blankDaysArr = [];
    for (let i = 1; i <= firstWeekdayNumber; i++) {
      blankDaysArr.push(i);
    }

    let daysInMonthArr = [];
    for (let i = 1; i <= daysInMonth; i++) {
      daysInMonthArr.push(i);
    }
    this.setState((prevState, _) => {
      return {
        ...prevState,
        month: newMonth,
        year: newYear,
        day: '',
        daysInMonthArr,
        blankDaysArr,
      };
    });
  };

  getDate = (date) => {
    const year = date.getFullYear();
    const monthNumber = monthsProps[date.getMonth()].CalendarMonthNumber;
    const month = ('0' + monthNumber).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${day}-${month}-${year}`;
  };

  formatYearsMonthDay = (date) => {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
  };

  isToday = (dayNumber) => {
    if(!dayNumber) return false
    const day = new Date(this.state.year, this.state.month, dayNumber);
    const selectedDate = this.state.day ? new Date(this.state.year, this.state.month, this.state.day) : new Date();
    return selectedDate.toDateString() === day.toDateString() ? true : false;
  };

  toggleDatePanel = () => {
    this.setState((prevState, _) => {
      return {
        ...prevState,
        isOpen: !prevState.isOpen,
      };
    });
  };
  toggleDisplayDateFocus = () => {
    /**
     * This functions triggers when the user clicks:
     * 1. The input element
     * 2. The input element goes out of focus
     * 3. A day in the calendar
     *
     * When the calendar input contains shadow-outline class it means it's focus,
     * so we remove that class and trigger blur programatically.
     * On the other hand if the input doesn't have the class, it means it's not focused,
     * so we trigger the focus and add the class.
     */
    const displayDate = document.getElementById('displayDateRef');
    if (displayDate.classList.contains('shadow-outline')) {
      displayDate.classList.remove('shadow-outline');
      displayDate.blur();
    } else {
      displayDate.classList.add('shadow-outline');
      displayDate.focus();
    }
    const daysDiv = document.getElementById('daysDivRef');
    daysDiv.focus();
  };


  FixTheDate = () =>{
    let displayDate = this.state.displayDate
    let aDate =  moment(displayDate,'DD-MM-YYYY',true)
    var isValid = aDate.isValid();
    if(isValid) {
      const today = new Date();
      const month =  parseInt(moment(displayDate, 'DD-MM-YYYY').format('MM')) - 1
      const year = moment(displayDate, 'DD-MM-YYYY').format('YYYY')

      const dayOfWeek = new Date(year, month).getDay();
      const Weekdays = daysProps[dayOfWeek].CalendarWeekdayNumber;
      // const displayDate = this.getDate(new Date(year, month, today.getDate()));
      const date = this.formatYearsMonthDay(new Date(year, month, today.getDate()));

      // Get last day number of the previous actual month
      const daysInMonth = new Date(year, month, 0).getDate();

      // Get the number (0-6) on which the actual month starts
      let blankDaysArr = [];
      for (let i = 1; i <= Weekdays; i++) {
        blankDaysArr.push(i);
      }

      let daysInMonthArr = [];
      for (let i = 1; i < daysInMonth; i++) {
        daysInMonthArr.push(i);
      }

      const selectDate = moment(displayDate , 'DD-MM-YYYY').format('DD')

      //setting date and time
      this.setState({
        date,
        displayDate: displayDate,
        month,
        year,
        daysInMonthArr,
        blankDaysArr,
        day: selectDate
      });
      this.props.handler(displayDate); 
    }
  }

  onChangeDate = (event) =>{
    let {name,value} = event
     let newState ={...this.state}
     newState = {...newState, displayDate : value}
    this.setState({...newState})
  }
  render() {
    return (
      <div>
      {this.props.label && <span className={` block ${this.props.labelClasses}`} style={{color : this.props.color, fontSize : this.props.size}}>{this.props.label}</span>}   
      <span className={`relative border-gray-200 bg-gray-100  ${this.props.classes}`}>
        <div id='displayDateRef' className='flex rounded-md border relative'>
        <div className={`absolute content-center text-center left-3 cursor-pointer ${this.props.classes}`}>
            <img src={calendar} style={{ width: 14 }} alt='calender' />
          </div>
              <input
                type='text'
                value={this.state.displayDate}
                disabled={this.props.disabled}
                onChange={(e) => this.onChangeDate(e.target)}
                style={{height : this.props.height}}
                onClick={() => {
                  !this.props.disabled && this.toggleDatePanel();
                }}
                onBlur={() => {
                  !this.props.disabled && this.setState({ isOpen: false });
                  this.FixTheDate()
                  this.props.onBlur && this.props.onBlur()
                }}
                className={`placeholder-gray-300 pl-10 border border-gray-100 font-semibold text-base rounded-md  focus:ring-blue-500 ${ this.props.disabled ? 'font-semibold text-base leading-4 w-full h-14 bg-gray-100 cursor-not-allowed text-gray-300' :  this.props.inputClasses}`}
                placeholder='DD-MM-YYYY'
              />  
          { this.props.close && this.state.displayDate &&<img src={close_icon} alt='cancel-icon' className='absolute top-5 right-3 h-3 w-3 cursor-pointer' onClick={() => this.setDate('')} />}
        </div>
        {this.props.error && <p className='text-red-300 font-sm text-normal flex flex-row'><img src={red_info} style={{marginRight : '5px'}}></img>{this.props.error}</p> }
        <div
          className={`focus:outline-none duration-200 bg-white rounded-lg shadow p-4 absolute left-10 ${
            !this.state.isOpen ? 'hidden opacity-0' : 'opacity-100'
          }`}
          style={{ width: '17rem', zIndex:2000 }}
          id='daysDivRef'
          tabIndex={-1}
        >
          <div className='flex justify-between items-center mb-2'>
            <div>
              <span className='text-lg font-semibold text-gray-800'>{months[this.state.month]}</span>
              <span className='ml-1 text-lg text-gray-600 font-normal'>{this.state.year}</span>
            </div>
            <div>
              <button
                type='button'
                className={`transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full focus:shadow-outline focus:outline-none mr-1`}
                onMouseDown={(event) => event.preventDefault()}
                onClick={this.subtractMonth}
              >
                <svg
                  className='h-6 w-6 text-gray-500 inline-flex'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M15 19l-7-7 7-7' />
                </svg>
              </button>
              <button
                type='button'
                onMouseDown={(event) => event.preventDefault()}
                className={`transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full focus:shadow-outline focus:outline-none`}
                onClick={this.addMonth}
              >
                <svg
                  className='h-6 w-6 text-gray-500 inline-flex'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M9 5l7 7-7 7' />
                </svg>
              </button>
            </div>
          </div>

          <div className='flex flex-wrap mb-3 -mx-1'>
            {days.map((day, index) => (
              <div key={index} style={{ width: '14.26%' }} className='px-1'>
                <div className='text-gray-800 font-semibold text-center text-xs'>{day}</div>
              </div>
            ))}
          </div>

          <div className='flex flex-wrap -mx-1'>
            {this.state.blankDaysArr.map((day) => (
              <div key={day} style={{ width: '14.28%' }} className='text-center  p-1 border-transparent text-sm' />
            ))}
            {this.state.daysInMonthArr.map((dayNumber, index) => (
              <div key={index} style={{ width: '14.28%' }} className='px-1 mb-1'>
                <div
                  onClick={() => this.setDate(dayNumber)}
                  onMouseDown={(event) => event.preventDefault()}
                  className={`cursor-pointer text-center text-sm leading-none rounded-full leading-loose transition ease-in-out duration-100 
                                                ${
                                                  this.isToday(dayNumber)
                                                    ? 'bg-blue-500 text-white'
                                                    : 'text-gray-700 hover:bg-blue-200'
                                                }`}
                >
                  {dayNumber}
                </div>
              </div>
            ))}
          </div>
        </div>
      </span>
      </div>
    );
  }
}

export default DatePicker;

